//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clickOutside } from "../../../utilities/directives/";
import SfOverlay from "../../atoms/SfOverlay/SfOverlay.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfChevron from "../../atoms/SfChevron/SfChevron.vue";
import { isClient } from "../../../utilities/helpers";
import {nextTick} from "@nuxtjs/composition-api";

export default {
  name: "SfDropdown",
  components: {
    SfOverlay,
    SfButton,
    SfChevron,
  },
  directives: {
    clickOutside,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    cancelButton: {
      type: String,
      default: ""
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    openerAriaLabel: {
      type: String,
      default: "",
    }
  },
  watch: {
    isOpen: {
      async handler(value) {
        if (!isClient) return;
        if (value) {
          document.addEventListener("keydown", this.keydownHandler);

          this.openUp = false;

          await nextTick(); // wait for the DOM to update

          const dropdownListEl = this.$refs.dropdownListRef;

          if (dropdownListEl) {
            const rect = dropdownListEl.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const dropdownBottom = rect.top + dropdownListEl.clientHeight;

            this.openUp = dropdownBottom > viewportHeight;
          }
        } else {
          document.removeEventListener("keydown", this.keydownHandler);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      openUp: false,
      isFocused: false,
    }
  },
  methods: {
    open() {
      this.$emit("click:open");
    },
    close() {
      this.$emit("click:close");
    },
    checkPersistence() {
      if (!this.persistent) return this.close();
    },
    keydownHandler(e) {
      if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
        this.close();
      }
    },
    checkFocus(e) {
      // Ensure the container exists before checking
      if (!this.$refs.container) return;

      if (!e.relatedTarget || !this.$refs.container.contains(e.relatedTarget)) {
        this.isFocused = false;
        this.close();
      }
    },
  },
};
